import React, { Component } from "react";
import $ from "jquery";
import { GetUserLogin } from "../../services";
import { getCookie } from "../../../function";
import { NotificationManager } from "react-notifications";

export default class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            remainingSeconds: null,
        };

        this.timer = null;
    }

    componentDidMount() {
        // Give the browser a moment to make sure
        // the token cookie is available after login.
        setTimeout(() => {
            this.updateRemainingTime();

            this.timer = setInterval(() => {
                this.updateRemainingTime();
            }, 1000);
        }, 100);
    }

    componentWillUnmount() {
        this.stopSessionTimer();
    }

    // ==========================================
    // STOP TIMER
    // ==========================================

    stopSessionTimer = () => {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    };

    // ==========================================
    // GET JWT PAYLOAD
    // ==========================================

    getJWTPayload = (token) => {
        try {
            const parts = token.split(".");

            if (parts.length !== 3) {
                return null;
            }

            let base64 = parts[1]
                .replace(/-/g, "+")
                .replace(/_/g, "/");

            // Add missing Base64 padding
            while (base64.length % 4 !== 0) {
                base64 += "=";
            }

            const decoded = window.atob(base64);

            return JSON.parse(decoded);
        } catch (error) {
            console.error(
                "Unable to decode JWT:",
                error
            );

            return null;
        }
    };

    // ==========================================
    // UPDATE REMAINING TIME
    // ==========================================

    updateRemainingTime = () => {
        const token = getCookie("token");

        // Token not available yet
        if (!token) {
            this.setState({
                remainingSeconds: null,
            });

            return;
        }

        const payload = this.getJWTPayload(token);

        if (!payload || !payload.exp) {
            console.error(
                "JWT does not contain a valid expiration time."
            );

            this.handleSessionExpired();
            return;
        }

        const expirationTime =
            Number(payload.exp) * 1000;

        const currentTime = Date.now();

        const remainingMilliseconds =
            expirationTime - currentTime;

        if (remainingMilliseconds <= 0) {
            this.handleSessionExpired();
            return;
        }

        const remainingSeconds = Math.ceil(
            remainingMilliseconds / 1000
        );

        this.setState({
            remainingSeconds,
        });
    };

    // ==========================================
    // SESSION EXPIRED
    // ==========================================

    handleSessionExpired = () => {
        this.stopSessionTimer();

        this.setState({
            remainingSeconds: 0,
        });

        NotificationManager.info(
            "Your login session has expired. Please login again.",
            "Session Expired"
        );

        GetUserLogin.logout();
    };

    // ==========================================
    // FORMAT TIME
    // ==========================================

    formatTime = (totalSeconds) => {
        if (
            totalSeconds === null ||
            totalSeconds === undefined
        ) {
            return "--:--";
        }

        if (totalSeconds <= 0) {
            return "00:00";
        }

        const hours = Math.floor(
            totalSeconds / 3600
        );

        const minutes = Math.floor(
            (totalSeconds % 3600) / 60
        );

        const seconds =
            totalSeconds % 60;

        if (hours > 0) {
            return (
                String(hours).padStart(2, "0") +
                ":" +
                String(minutes).padStart(2, "0") +
                ":" +
                String(seconds).padStart(2, "0")
            );
        }

        return (
            String(minutes).padStart(2, "0") +
            ":" +
            String(seconds).padStart(2, "0")
        );
    };

    // ==========================================
    // TIMER STYLE
    // ==========================================

    getTimerStyle = () => {
        const {
            remainingSeconds,
        } = this.state;

        // Loading / token not available yet
        if (
            remainingSeconds === null ||
            remainingSeconds === undefined
        ) {
            return {
                background: "#6c757d",
                color: "#fff",
            };
        }

        // Last 1 minute
        if (remainingSeconds <= 60) {
            return {
                background: "#dc3545",
                color: "#fff",
            };
        }

        // Last 5 minutes
        if (remainingSeconds <= 300) {
            return {
                background: "#ffc107",
                color: "#212529",
            };
        }

        // Normal session
        return {
            background: "#343a40",
            color: "#fff",
        };
    };

    // ==========================================
    // SIDEBAR
    // ==========================================

    toggleSidebar = () => {
        if (
            !$("body").hasClass(
                "sb-sidenav-toggled"
            )
        ) {
            $("body").addClass(
                "sb-sidenav-toggled"
            );
        } else {
            $("body").removeClass(
                "sb-sidenav-toggled"
            );
        }
    };

    // ==========================================
    // RENDER
    // ==========================================

    render() {
        const {
            remainingSeconds,
        } = this.state;

        const timerStyle =
            this.getTimerStyle();

        return (
            <div>
                <nav
                    className="sb-topnav navbar navbar-expand navbar-light bg-clr"
                    style={{
                        minHeight: "56px",
                    }}
                >

                    {/* LOGO */}

                    <img
                        src="/images/JC-logo.png"
                        width="40px"
                        alt="JC-logo"
                    />

                    <a
                        className="navbar-brand logo-brand"
                        href="/"
                    >
                        JC Creations
                    </a>

                    {/* SIDEBAR BUTTON */}

                    <button
                        className="btn btn-link btn-sm order-1 order-lg-0"
                        id="sidebarToggle"
                        onClick={this.toggleSidebar}
                    >
                        <i className="fas fa-bars" />
                    </button>

                    {/* HOME */}

                    <a
                        href="/"
                        className="frnt-link"
                    >
                        <i className="fas fa-external-link-alt" />
                        Home
                    </a>

                    {/* RIGHT SIDE */}

                    <ul className="navbar-nav ml-auto mr-md-0">

                        {/* ==================================
                            SESSION TIMER
                        ================================== */}

                        <li
                            className="nav-item d-flex align-items-center"
                            style={{
                                marginRight: "15px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",

                                    padding:
                                        "7px 14px",

                                    minWidth:
                                        "125px",

                                    justifyContent:
                                        "center",

                                    borderRadius:
                                        "20px",

                                    fontSize: "13px",

                                    fontWeight:
                                        "600",

                                    letterSpacing:
                                        "0.3px",

                                    boxShadow:
                                        "0 2px 6px rgba(0,0,0,0.15)",

                                    transition:
                                        "all 0.3s ease",

                                    ...timerStyle,
                                }}
                                title="Login session remaining time"
                            >

                                <i
                                    className="fas fa-clock"
                                    style={{
                                        fontSize:
                                            "13px",
                                    }}
                                />

                                <span>
                                    Session
                                </span>

                                <span
                                    style={{
                                        fontFamily:
                                            "monospace",

                                        fontSize:
                                            "14px",

                                        fontWeight:
                                            "700",

                                        minWidth:
                                            "50px",

                                        textAlign:
                                            "center",
                                    }}
                                >
                                    {this.formatTime(
                                        remainingSeconds
                                    )}
                                </span>

                            </div>
                        </li>

                        {/* ==================================
                            USER DROPDOWN
                        ================================== */}

                        <li className="nav-item dropdown">

                            <a
                                className="nav-link dropdown-toggle"
                                id="userDropdown"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="fas fa-user fa-fw" />
                            </a>

                            <div
                                className="dropdown-menu dropdown-menu-right"
                                aria-labelledby="userDropdown"
                            >

                                <a
                                    className="dropdown-item admin-dropdown-item"
                                    href="edit_profile.html"
                                >
                                    Edit Profile
                                </a>

                                <a
                                    className="dropdown-item admin-dropdown-item"
                                    href="change_password.html"
                                >
                                    Change Password
                                </a>

                                <span
                                    className="dropdown-item admin-dropdown-item"
                                    onClick={() =>
                                        GetUserLogin.logout()
                                    }
                                    style={{
                                        cursor:
                                            "pointer",
                                    }}
                                >
                                    Logout
                                </span>

                            </div>

                        </li>

                    </ul>

                </nav>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/header/index.js